import {getField, updateField} from 'vuex-map-fields';
import ConsumerModule from '@/commonFunction/consumerModule'

let current_module = new ConsumerModule('/ws/mcomponent/component/');

const state = {
    ...current_module.state,
    columns: [
        {text: 'Alias', value: 'alias', sortable: true, filterable: true, divider: true,},
    ],
    options: {
        page: 1,
        itemsPerPage: -1,
        sortBy: ['alias'],
        sortDesc: [false],
        multiSort: false,
        mustSort: false,
        descending: true,
    },
    filterGroupSingle: [],
};

const getters = {
    ...current_module.getters,
    getColumns(state) {
        return state.columns
    },
};
const actions = {
    ...current_module.actions,
};
const mutations = {
    ...current_module.mutations,
};

export default {
    modules: {
        ComponentAliasSelectTable: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}